import React from 'react';
import { Tooltip } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  baseLayerContainer: {
    position: 'absolute',
  },

  centeringContainer: {
    position: 'absolute',
    left: -2,
  },
});

const PPCC = () => {
  return (
    <span className={css(styles.baseLayerContainer)}>
      <span className={css(styles.centeringContainer)}>
        <Tooltip name="ppcc-preview" verifiedIcon />
      </span>
    </span>
  );
};

export default PPCC;
